/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Ref_H1Inputs */

const en_minifier_ref_h1 = /** @type {(inputs: Minifier_Ref_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stage`)
};

const ko_minifier_ref_h1 = /** @type {(inputs: Minifier_Ref_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`단계`)
};

const ja_minifier_ref_h1 = /** @type {(inputs: Minifier_Ref_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`段階`)
};

/**
* | output |
* | --- |
* | "Stage" |
*
* @param {Minifier_Ref_H1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_ref_h1 = /** @type {((inputs?: Minifier_Ref_H1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Ref_H1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_ref_h1(inputs)
	if (locale === "ko") return ko_minifier_ref_h1(inputs)
	return ja_minifier_ref_h1(inputs)
});